import { useMediaQuery } from "@/ui/hooks/useMediaQuery";
import { createPortal } from "react-dom";
import { Fragment } from "react/jsx-runtime";

export function SidebarPortal({ children }: { children: React.ReactNode }) {
    const isMobile = useMediaQuery("(max-width: 1023px)");
    const portalContainer = document.getElementById("sidebar-content");
    const mobilePortalContainer = document.getElementById(
        "mobile-sidebar-content",
    );

    return (
        <Fragment>
            {portalContainer &&
                isMobile === false &&
                createPortal(children, portalContainer)}
            {mobilePortalContainer &&
                isMobile === true &&
                createPortal(children, mobilePortalContainer)}
        </Fragment>
    );
}

export function SidebarHeader({ children }: { children: React.ReactNode }) {
    const portalContainer = document.getElementById("sidebar-header");
    const mobilePortalContainer = document.getElementById(
        "mobile-sidebar-header",
    );

    return (
        <Fragment>
            {portalContainer && createPortal(children, portalContainer)}
            {mobilePortalContainer &&
                createPortal(children, mobilePortalContainer)}
        </Fragment>
    );
}
